import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const StudioFill = forwardRef<SVGSVGElement, IconProps>(
  ({ size = 16, color = 'currentColor' }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path d="M10.281 6.76312L2.03101 1.99998L2.031 11.5263L10.281 6.76312Z" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.20825 4.76773L2.50002 2.62678L2.50002 10.7415L6.20823 8.60055C5.93417 8.01913 5.78094 7.36954 5.78094 6.68417C5.78094 5.99877 5.93418 5.34916 6.20825 4.76773ZM6.73289 3.91593L2.25002 1.32774C1.91669 1.13529 1.50002 1.37586 1.50002 1.76076L1.50002 11.6075C1.50002 11.9924 1.91669 12.233 2.25002 12.0405L6.73286 9.45236C7.55645 10.5065 8.83956 11.1842 10.2809 11.1842C12.7662 11.1842 14.7809 9.16945 14.7809 6.68417C14.7809 4.19888 12.7662 2.18416 10.2809 2.18416C8.83958 2.18416 7.55648 2.86183 6.73289 3.91593ZM7.60988 8.94601C8.25189 9.70342 9.21028 10.1842 10.2809 10.1842C12.2139 10.1842 13.7809 8.61716 13.7809 6.68417C13.7809 4.75117 12.2139 3.18416 10.2809 3.18416C9.2103 3.18416 8.25193 3.6649 7.60992 4.42228L10.7776 6.25112C11.1109 6.44357 11.1109 6.9247 10.7776 7.11715L7.60988 8.94601ZM7.07834 8.09819L9.52757 6.68413L7.07836 5.27009C6.88715 5.70251 6.78094 6.18094 6.78094 6.68417C6.78094 7.18737 6.88714 7.66578 7.07834 8.09819ZM12.7809 12.0001C13.6094 12.0001 14.2809 12.6716 14.2809 13.5001C14.2809 14.3285 13.6094 15.0001 12.7809 15.0001H11.5034L11.5 15.0001L11.4965 15.0001L6.00536 15.0001C5.46753 15.0001 4.93694 14.8761 4.45477 14.6378L3.05944 13.9483C2.88927 13.8642 2.78139 13.691 2.78095 13.5012C2.78051 13.3114 2.88757 13.1377 3.05734 13.0529L4.4239 12.3696C4.9099 12.1266 5.44579 12.0001 5.98915 12.0001L12.7809 12.0001ZM12 14.0001H12.7809C13.0571 14.0001 13.2809 13.7762 13.2809 13.5001C13.2809 13.2239 13.0571 13.0001 12.7809 13.0001L12 13.0001V14.0001ZM11 14.0001L6.00536 14.0001C5.62119 14.0001 5.2422 13.9115 4.8978 13.7413L4.40424 13.4974L4.87112 13.264C5.21826 13.0904 5.60104 13.0001 5.98915 13.0001L11 13.0001V14.0001Z"
          fill={color}
        />
        <path
          d="M14.281 7C14.281 9.20914 12.4901 11 10.281 11C8.07187 11 6.28101 9.20914 6.28101 7C6.28101 4.79086 8.07187 3 10.281 3C12.4901 3 14.281 4.79086 14.281 7Z"
          fill={color}
          fillOpacity="0.05"
        />
      </svg>
    )
  },
)

export default StudioFill
